import ICompLocalVersions from './comp/ICompLocalVersions';
import ICompNotesData from './comp/ICompNotesData';
import ICompAddress, { newCompAddress } from './CompAddress';
import ICompData from './comp/ICompData';
import IFeedData from './comp/IFeedData';
import ILookup from './common/ILookup';
import ISubCompDatas from './comp/ISubCompDatas';

export default interface IComp {
    address: ICompAddress;
    compNumber: number;
    compType?: string;
    compKey?: string;
    formCode: string;
    qsGuid: string;
    isLoading?: boolean;
    isSubject?: boolean;
    hasVisited?: boolean;
    isActive?: boolean;
    propertyPhoto?: string;
    sourceData?: ICompData[];
    sourceDataPR?: IFeedData;
    sourceDataSE?: IFeedData;
    sourceDataMLS?: IFeedData;
    sourceDataDB?: IFeedData;
    sourceDataFF?: IFeedData;
    localVersions: ICompLocalVersions;
    notesData: ICompNotesData;
    subCompData?: ILookup<ISubCompDatas>;
}

export function newComp(): IComp {
    const result: IComp = {
        address: newCompAddress(),
        compNumber: 0,
        formCode: '',
        qsGuid: '',
        localVersions: [],
        notesData: [],
    };
    return result;
}
